import { isPlatformTrucktour } from "@infrastructure/Services/EnvService";
import { useGlobalConfigs } from "@infrastructure/Hooks/useGlobalConfigs";

const DEFAULT_CREATE_POST_PLACEHOLDER = "Was machst du gerade?";

export type PostFormConfig = {
    addLinkEnabled: boolean;
    addLocationEnabled: boolean;
    addPollEnabled: boolean;
    addVideoEnabled: boolean;
    createPostPlaceholder: string;
};

export function usePostFormConfig(): PostFormConfig {
    const tippspielConfig = useTippspielPostFormConfig();
    const trucktourConfig = useTrucktourPostFormConfig();

    return isPlatformTrucktour ? trucktourConfig : tippspielConfig;
}

export function useTrucktourPostFormConfig(): PostFormConfig {
    const { getConfigs } = useGlobalConfigs();

    return {
        addVideoEnabled:
            getConfigs()?.truckTourCreatePostAddVideoEnabled ?? false,
        addLocationEnabled:
            getConfigs()?.truckTourCreatePostAddLocationEnabled ?? false,
        addPollEnabled:
            getConfigs()?.truckTourCreatePostAddPollEnabled ?? false,
        addLinkEnabled:
            getConfigs()?.truckTourCreatePostAddLinkEnabled ?? false,
        createPostPlaceholder:
            getConfigs()?.truckTourFeedCreatePostPlaceholder ??
            DEFAULT_CREATE_POST_PLACEHOLDER,
    };
}

export function useTippspielPostFormConfig(): PostFormConfig {
    const { getConfigs } = useGlobalConfigs();

    return {
        addVideoEnabled:
            getConfigs()?.tippspielCreatePostAddVideoEnabled ?? false,
        addLocationEnabled:
            getConfigs()?.tippspielCreatePostAddLocationEnabled ?? false,
        addPollEnabled:
            getConfigs()?.tippspielCreatePostAddPollEnabled ?? false,
        addLinkEnabled:
            getConfigs()?.tippspielCreatePostAddLinkEnabled ?? false,
        createPostPlaceholder:
            getConfigs()?.tippspielFeedCreatePostPlaceholder ??
            DEFAULT_CREATE_POST_PLACEHOLDER,
    };
}
